import Flickity from "flickity";
require('flickity-imagesloaded');
require('flickity-fade');

class ImageCarousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.fade = self.elem.getAttribute('data-fade') === 'true' ? true : false;
        self.slideDuration = parseInt(self.elem.getAttribute('data-duration'));
    }

    init() {
        let self = this;

        // Init Flickity
        const flkty = new Flickity( self.elem, {
            autoPlay: self.slideDuration,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            pauseAutoPlayOnHover: false,
            imagesLoaded: true,
            fade: self.fade ? true : false,
            selectedAttraction: self.fade ? 0.008 : 1,
            friction: self.fade ? 0.28 : 1
        });
    }
}

export default ImageCarousel;
